// @ts-nocheck
import * as api from './api';
import * as reporter from './reporter';

import util from '../../loader/utils/util';

import tips from '../../loader/widget/tips';
import nmcConfig from '../../loader/config/config';
import dialog from '../../loader/widget/dialog';
import router from '../../loader/lib/router';
import * as tcesdk from '@tencent/tce-sdk';
import lang from '../config/i18n/lang';

var login: any = {};
var cam: any = {};

// 截取message中的IP
function getMessageIP(message) {
  var ip = '';
  if (message) {
    const temp = message.split('`');
    if (temp.length > 2) {
      ip = temp[1];
    }
  }
  return ip;
}

function printYapiErrorLog(url, req, res, interfaceName) {
  var logDetails = [
    {
      key: '云API地址',
      value: url
    },
    {
      key: '入参',
      value: req
    },
    {
      key: '出参',
      value: res
    }
  ];
  tcesdk.utils.printKeywordLog('yapi接口报错，接口名：' + interfaceName, logDetails);
}

var domain =
  'iaas.' + location.hostname.substring(location.hostname.indexOf('.') + 1);

var proxyReady = function (id) {
  id = id || 'qcbase-proxy';
  var iframe;

  return new Promise(function (resolve, reject) {
    iframe = document.getElementById(id);
    if (iframe) {
      // iframe 中的 domain 可能还没生效
      try {
        if (iframe.contentWindow.postSend) {
          return resolve(iframe.contentWindow.postSend);
        }
      } catch (e) {}
    } else {
      iframe = document.createElement('iframe');
      iframe.id = id;
      iframe.style.display = 'none';
      iframe.src = '//' + domain + '/proxy.html';
      document.body.appendChild(iframe);
    }
    iframe.addEventListener('load', function () {
      try {
        resolve(iframe.contentWindow.postSend);
      } catch (e) {
        reject(e);
      }
    });
    iframe.addEventListener('error', reject);
  });
};

/**
 * 请求 iaas.qcloud.com
 * @param {String} url 请求 endpoint
 * @param {Object} param 请求参数
 * @param {Object} [opts] 配置项
 * @param {Boolean} opts.global=true 是否显示全局加载条
 * @param {Boolean} opts.tipErr=true 是否显示失败提示
 * @param {Boolean} opts.classicResponse=true 是否使用经典的 json 回包(code=0, 表示成功, 其他表示失败)
 */
let request = function (url, param, opts) {
  opts = opts || {};
  var startTime;

  return proxyReady()
    .then(function (postSend) {
      startTime = Date.now();
      return postSend(url, param, opts);
    })
    .then(function (data) {
      var timeCost = Date.now() - startTime;
      reporter.report(data, timeCost, url, opts);

      //云apiv3 无code，直接返回
      if (opts.v3) {
        /*only,en;
                data = nmcConfig.adapter(data)
                only*/
        return data;
      }
      if (opts.classicResponse === false) {
        /*only,en;
                  data = nmcConfig.adapter(data)
                  only*/
        return data;
      } else {
        if (data.code == 0) {
          /*only,en;
                         data = nmcConfig.adapter(data)
                         only*/
          return data.data;
        } else {
          throw data;
        }
      }
    })
    .catch(function (e) {
      // http status code, http 状态码上报
      var timeCost = Date.now() - startTime;
      reporter.report({ code: e.status }, timeCost, url, opts);
      throw e;
    });
};
// 合并参数+url相同的请求
var keyGen = function (url, param) {
  return url + '\n' + JSON.stringify(param);
};
api.duplicatePromiseCombine(request, keyGen);

/**
 * 请求后端capi中间层
 * @param {String} url 请求 endpoint
 * @param {Object} param 请求参数
 * @param {Object} [opts] 配置项
 * @param {Boolean} opts.global=true 是否显示全局加载条
 * @param {Boolean} opts.tipErr=true 是否显示失败提示
 * @param {Boolean} opts.classicResponse=true 是否使用经典的 json 回包(code=0, 表示成功, 其他表示失败)
 */
var tapiRequest = function (url, param, opts) {
  opts = opts || {};
  var startTime;

  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'post',
      url: url,
      beforeSend: function (request) {
        request.setRequestHeader('X-CsrfCode', tcesdk.security.getCSRFToken());
      },
      xhrFields: {
        withCredentials: true
      },
      dataType: 'json',
      async: opts.async,
      contentType: 'application/json; charset=utf-8', // 先暂时屏蔽，需要后端处理options的请求
      data: JSON.stringify(param),
      success: function (resp) {
        var timeCost = Date.now() - startTime;
        reporter.report(resp, timeCost, url, opts);

        // 按照原来qcbase的逻辑处理resp返回
        resp = util.revertResp(resp);

        //云apiv3 无code，直接返回
        if (opts.v3) {
          resolve(resp);
        }
        if (opts.classicResponse === false) {
          resolve(resp);
        } else {
          if (resp.code == 0) {
            resolve(resp.data);
          } else {
            // 如果接口没有返回正常信息打印日志
            printYapiErrorLog(
              url,
              param,
              resp,
              param.serviceType + '/' + param.action
            );
            reject(resp);
          }
        }
      },
      error: function (error) {
        var timeCost = Date.now() - startTime;
        reporter.report({ code: error.status }, timeCost, url, opts);
        reject(error);
      }
    });
  });
};

/**
 * 云 api 代理
 * @param {Object} [opts] 配置项. 参考 opts.request 的配置项
 * @param {Boolean} opts.camTips=true cam 鉴权失败时, 是否提示
 * @param {String} opts.camTipsType [dialog] cam 失败时, 可选弹框提示
 */
var apiRequest = async function (data, opts) {
  //data.cmd: 兼容 console 云 api 接口透传参数名
  if (data.cmd && !data.action) {
    data.action = data.cmd;
  }
  data.data = data.data || {};
  if (opts && opts.v3) {
    data.data.Version = '2017-03-12';
  }
  var action = (data.data && data.data.Action) || data.action || '';

  if (router.debug && !data.regionId && !data.data.region) {
    console.warn(data.serviceType, action);
    console.warn(
      '请传入 regionId! 没有传入 regionId / region 时会隐式使用 cookie 中的 regionId, 这可能会造成请求地域混乱'
    );
  }

  var baseUrl = '//tapi.' + window.hostConfig.mainHost + '/capi';
  // 判断是否为云API3
  if ((opts && opts.v3) || data.data.Version) {
    baseUrl += '/v3';
    // 还需要将入参中的小写转换为大写的
    data.data = util.toUpperCaseFL(data.data);
  } else {
    baseUrl += '/v2';
  }

  // 判断是否为云API3
  if ((opts && opts.v3) || data.data.Version) {
    // 还需要将入参中的小写转换为大写的
    data.data = util.toUpperCaseFL(data.data);
  }

  // 获取region
  const resp = await tcesdk.region.getCurrentRegionAsync(data.regionId);
  data.region = resp.region;
  delete data.regionId;

  const yapiUrl = baseUrl + '?i=' + data.serviceType + '/' + action;
  const reqData = data;

  return tapiRequest(yapiUrl, data, opts)
    .then(function (data) {
      if (data && data.Response && data.Response.Error) {
        // 如果接口没有返回正常信息打印日志
        printYapiErrorLog(
          yapiUrl,
          reqData,
          data,
          reqData.serviceType + '/' + action
        );

        var message = data.Response.Error.Message;
        var ip = getMessageIP(message);
        if (data.Response.Error.Code === 'UnauthorizedOperation.InvalidAccessIP') {
          tcesdk.platform.showPreLoginModal(
            lang.t('ipLimitModal.title'),
            lang.t('ipLimitModal.description').replace('{{ip}}', ip)
          );
          return;
        }
      }

      if (opts && (opts.classicResponse === false || opts.v3)) {
        if (data && data.code) {
          throw data;
        }

        if (opts.classicResponse === false) {
          data = data.data;
          if (data && data.Response && data.Response.Error) {
            // 如果接口没有返回正常信息打印日志
            printYapiErrorLog(
              yapiUrl,
              reqData,
              data,
              reqData.serviceType + '/' + action
            );
            throw {
              code: data.Response.Error.Code,
              message: data.Response.Error.Message
            };
          }
        }
      }

      if (opts && opts.v3) {
        data = util.toLowerCaseFL(data.data || {});
        if (data && data.response && data.response.error) {
          // 如果接口没有返回正常信息打印日志
          printYapiErrorLog(
            yapiUrl,
            reqData,
            data,
            reqData.serviceType + '/' + action
          );
          throw {
            code: data.response.error.code,
            message: data.response.error.message
          };
        }
      }
      return data;
    })
    .catch(errorHandler(opts));
};

var errorHandler = function (opts) {
  opts = opts || {};
  opts.camTipsType = opts.camTipsType || 'dialog';

  return function (data) {
    if (data && data.code) {
      var code = data.code;
      var message = data.message;
      if (data.data && data.data.code) {
        // 兼容V2的场景
        code = data.data.code;
        message = data.data.message;
      }
      var ip = getMessageIP(message);
      // V3和V2错误码不同
      if (code === 'UnauthorizedOperation.InvalidAccessIP' || code === 4700) {
        tcesdk.platform.showPreLoginModal(
          lang.t('ipLimitModal.title'),
          lang.t('ipLimitModal.description').replace('{{ip}}', ip)
        );
        return;
      }
    }

    if (typeof opts.error == 'function') {
      data = opts.error(data);
    }

    // 是否显示提示
    var message;

    if (cam.isCamRefused && cam.isCamRefused(data)) {
      if (opts.camTips !== false) {
        if (opts.camTipsType == 'dialog') {
          var bee = new Bee('<div><cam-tips>' + data.message + '</cam-tips></div>');

          dialog.create(bee.$el, 820, '', {
            title: '您没有权限执行此操作',
            defaultCancelBtn: false,
            button: {
              确定: function () {
                dialog.hide();
              }
            }
          });
        } else {
          message = data.message;
        }
      }
    } else if (data.cgwCode == 800200) {
      dialog.confirm(
        '您的账号暂未完成实名认证，请前往完成实名认证！',
        function () {
          router.navigate('/developer/auth');
        },
        function () {},
        {
          title: '提示',
          width: 480,
          mainBtnName: '前往认证',
          defaultCancelBtn: false
        }
      );
    } else {
      message =
        (data.code ? '[' + data.code + '] ' : '') +
        (data.message || nmcConfig.defaultReqErr);
    }

    if (data.code == 'VERIFY_LOGIN_FAILED' || String(data.code) === '401') {
      tcesdk.platform.showPreLoginModal(
        lang.t('loginExpireModal.title'),
        lang.t('loginExpireModal.description')
      );
      return;
    }
    if (opts.tipErr !== false) {
      if (message) {
        tips.error(message);
      }
    }
    throw data;
  };
};

/**
 * 专线接口代理
 */
var dcRequest = function (data, opts) {
  return request(
    '/cgi/dc?action=delegate&i=' + data.interface + '&uin=' + util.getUin(),
    data,
    opts
  );
};

/**
 * 日志服务接口代理
 */
var cloudLogRequest = function (data, opts) {
  return request('/cgi/cloudLog?action=delegate&i=' + data.interface, data, opts);
};

/**
 *
 * @param {Object} data graphql 参数, 如: `{ regionId: 1, variables: {}, query: '{ resouce{...} }', operationName: 'dfw' }`
 * @param {*} opts
 */
var gqlRequest = function (data, opts) {
  var url = '/cgi/graphql';
  if (data.operationName) {
    url += '?operationName=' + data.operationName + '&uin=' + util.getUin();
  } else {
    url += '?uin=' + util.getUin();
  }
  return request(url, data, $.extend({ classicResponse: false }, opts));
};

/**
 * 获取graphql层级里指定的属性
 * 例如
 * @param {*} pathArray 如 ['resource', 'loadbalance', 'list']
 * @param {*} data 如 { resource: { loadbalance: { list: {...} } } }
 * @return {*} 返回对应层级的数据，如果没有此层级，返回null
 */
function getGqlData(pathArray, data) {
  var o = data,
    i,
    key;
  for (i = 0; i < pathArray.length; i++) {
    key = pathArray[i];
    if (o && key in o) {
      o = o[key];
    } else {
      return null;
    }
  }
  return o;
}

/**
 * 获取 graphql 错误提示
 * @param {Array} pathArray 数据路径
 * @param {Array} errors graphql接口返回的错误列表
 * @return {*} error
 */
function getGqlError(pathArray, errors) {
  pathArray = pathArray || [];
  var path = pathArray.join('.');
  errors = errors || [];
  var i, e;
  for (i = 0; i < errors.length; i++) {
    e = errors[i];
    if ((e.path || []).join('.') == path) {
      return JSON.parse(e.message);
    }
  }
  return null;
}

function wrapSchema(schema, paths, thisParams) {
  var out;
  out =
    '{' +
    paths[0] +
    (paths.length > 1 ? wrapSchema(schema, paths.slice(1)) : schema) +
    '}';
  if (thisParams) {
    out = '(' + thisParams + ')' + out;
  }
  return out;
}

/**
 * 简化的gql请求，用于请求单个gql节点
 * @param {Object} data
 *  {Number} data.regionId
 *  {String[]} data.path 请求的路径，例如 ['resource', 'loadbalance', 'list']
 *  {String} data.schema 返回格式，例如 "{totalCount nodes{ id name, vpcId @include(if:$getVpc) }}"
 *  {Object} data.[params] 请求参数，例如 {offset:0, limit:20}
 *  {Object} data.[paramsSchema] 支持的参数，例如 { offset: 'Int', limit: 'Int' }
 *  {Object} data.[localParamsSchema] 用户自定义参数，用于schema中使用条件语句，例如 { getVpc: 'Boolean' }
 * @return { data, error, errors } 返回数据，如果是当前层级的错误，会放在error中。
 */
export function singleGqlRequest(data, opts) {
  data = data || {};
  var regionId = data.regionId;
  var pathArray = data.path;
  var schema = data.schema;
  var queryData = data.params;
  var params = data.paramsSchema;
  var localParams = data.localParamsSchema;

  var paramKeys = Object.keys(params || {});
  var fullParams = $.extend({}, params, localParams);
  // 参数类型定义
  var paramsDefine = Object.keys(fullParams)
    .map(function (key) {
      return '$' + key + ': ' + fullParams[key];
    })
    .join(', ');
  if (paramsDefine) {
    paramsDefine = '(' + paramsDefine + ')';
  }
  // Schema中的参数映射
  var paramsMap = paramKeys
    .map(function (key) {
      return '' + key + ': $' + key;
    })
    .join(', ');
  if (paramsMap) {
    paramsMap = '(' + paramsMap + ')';
  }
  // schema拼装
  var querySchema = wrapSchema(paramsMap + schema, pathArray);
  return gqlRequest(
    {
      regionId: regionId,
      variables: queryData,
      operationName: null,
      query: 'query ' + paramsDefine + querySchema
    },
    opts
  ).then(
    function (response) {
      if (response.code) {
        return {
          error: response
        };
      }
      var errors = response.errors;
      var result = getGqlData(pathArray, response.data);
      return {
        data: result,
        error: getGqlError(pathArray, errors) || (errors && errors[0]),
        errors: errors
      };
    },
    function (e) {
      return {
        data: null,
        error: e,
        errors: [
          {
            path: pathArray,
            message: JSON.stringify(e)
          }
        ]
      };
    }
  );
}

/**
 * 查询白名单
 * @param {String[]} whitelistKeys 需要查询的白名单key
 * @param {String} type 查询的类型，可以为 'appid' | 'uin' | 'owneruin' | 'anonymous'
 */
export function getWhiteList(whitelistKeys, type) {
  var url = '/cgi/whitelist';
  return request(
    url,
    { whitelistKeys: whitelistKeys, type: type },
    { classicResponse: false }
  );
}
let ready = proxyReady;

export {
  ready,
  request,
  apiRequest,
  dcRequest,
  cloudLogRequest,
  gqlRequest,
  getGqlError,
  errorHandler
};
